var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGirlHead6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 530,
    height: 558,
    viewBox: "0 0 530 558",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Girl / Head / 6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Hair",
    d: "M315.493 390.811H164.793L142.092 390.811C142.092 390.811 138.312 333.439 179.232 286.555C191.072 272.983 192.952 261.135 192.632 248.131C192.352 236.945 190.472 224.887 191.932 210.123C200.652 147.945 249.012 99.9985 317.192 99.9985C377.432 99.9985 437.03 137.221 453.512 188.943C464.174 222.403 463.062 241.639 459.66 267.975C453.2 318.013 482.738 318.305 495.764 352.473C504.64 375.757 498.152 390.811 498.152 390.811H315.493V390.811Z",
    fill: "#F6B852"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M332.523 365.58C332.523 365.58 306.661 366.344 295.639 360.324L331.149 382.618L332.523 365.58Z",
    fill: "#CF3E83"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Face color"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Face",
    d: "M429.971 258.97C427.03 288.8 417.641 338.636 390.161 356.913C376.979 365.679 352.975 366.761 332.523 365.581L327.835 423.667C327.835 423.667 255.979 410.253 261.741 405.199C262.267 404.737 263.043 398.641 263.895 390.811H315.492C315.492 351.325 262.402 339.567 285.786 303.457C307.974 269.197 360.306 331.869 405.126 247.405C405.59 246.533 406.041 245.668 406.481 244.811C413.22 250.857 421.153 255.71 429.971 258.97Z",
    fill: "#E576C6"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Fill 9",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M388.741 274.218L403.541 310.1L386.371 309.754L388.741 274.218Z",
    fill: "#405FD3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 13",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M418.358 274.629C417.988 281.797 413.774 287.381 408.942 287.103C404.11 286.825 400.492 280.789 400.86 273.621C401.23 266.453 405.444 260.869 410.276 261.147C415.108 261.425 418.726 267.463 418.358 274.629Z",
    fill: "#0D0B6D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 17",
    d: "M382.159 326.94C382.159 326.94 370.971 330.55 359.759 318.086",
    stroke: "#1C295E",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 19",
    opacity: 0.397507,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M332.48 365.579C332.48 365.579 306.62 366.343 295.596 360.323L331.106 382.617L332.48 365.579Z",
    fill: "black"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGirlHead6);
export default __webpack_public_path__ + "static/media/Girl-Head-6.bac726fb.svg";
export { ForwardRef as ReactComponent };